<template>
  <div class="course-search">
    <app-header />
    <main>
      <div class="container-fluid">
        <b-form class="course-search-form" @submit.prevent="onSubmit">
          <b-form-group>
            <fa-icon icon="search" class="input-icon" />
            <img
              class="input-clear"
              src="../../assets/img/common/input-clear.png"
              alt="Search Clear"
              @click="searchClear">
            <b-form-input
              v-model="coursesFilter.keyword"
              class="form-control-custom"
              placeholder="ค้นหาคอร์สเรียน">
            </b-form-input>
          </b-form-group>
        </b-form>

        <courses :courses="courses" />
      </div>
    </main>
    <app-footer />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AppHeader from '../../components/Header.component'
  import AppFooter from '../../components/Footer.component'
  import Courses from '../../components/learning/Courses.component'

  export default {
    name: 'course',
    components: {
      AppHeader,
      AppFooter,
      Courses
    },

    computed: {
      // Map Vuex state.
      ...mapState({
        courses: state => {
          return state.Course.courses
        },
        coursesFilter: state => {
          return state.Course.coursesFilter
        }
      })
    },

    created () {
      return this.$store.dispatch(`Course/getCourses`)
    },

    methods: {
      onSubmit () {
        return this.$store.dispatch(`Course/getCourses`)
      },
      searchClear () {
        return this.$store.dispatch('Course/setCoursesFilter', {
          keyword: ''
        })
          .then(() => this.$store.dispatch('Course/getCourses'))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/styles";

  main {
    margin-top: calc(#{$header-height} + 15px);
  }
</style>



// WEBPACK FOOTER //
// src/pages/learning/CourseSearch.page.vue